export default {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}
